import React, { Component } from 'react';
import { func, string, bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  actions,
  getPostInfo,
  getLoginDialogOpen,
} from '@blueberry/redux/post';

import LoginDialog from './components/LoginDialog';

import styles from './LikeBlock.scss';
const cx = require('classnames/bind').bind(styles);

import likeActive from './images/ic-like-active.svg';
import likeInActive from './images/ic-like-inactive.svg';

const mapStateToProps = state => ({
  postId: getPostInfo(state, 'id'),
  isLike: getPostInfo(state, 'isLike'),
  userInfo: state.profile.data,
  isLoginDialogOpen: getLoginDialogOpen(state),
});

class LikeBlock extends Component {
  static propTypes = {
    isLike: bool.isRequired,
    isLoginDialogOpen: bool.isRequired,
    postId: string.isRequired,
    showLoginDialog: func.isRequired,
    toggleFavorite: func.isRequired,
    userInfo: object,
    withCycle: bool,
  };

  static defaultProps = {
    userInfo: {},
    withCycle: false,
  };

  handleLikeClick = () => {
    const {
      toggleFavorite,
      userInfo: { userId },
      postId,
      showLoginDialog,
    } = this.props;

    if (!userId) {
      showLoginDialog();

      return;
    }

    toggleFavorite(postId);
  };

  render() {
    const { isLoginDialogOpen, isLike } = this.props;

    return (
      <div className={styles.root}>
        <div
          className={cx(styles.iconBlock, { active: isLike })}
          onClick={this.handleLikeClick}
        >
          <img
            src={isLike ? likeActive : likeInActive}
            className={styles.likeIcon}
          />
        </div>
        {isLoginDialogOpen && <LoginDialog />}
      </div>
    );
  }
}

export default compose(
  connect(mapStateToProps, {
    toggleFavorite: actions.toggleFavorite,
    showLoginDialog: actions.showLoginDialog,
  })
)(LikeBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/LikeBlock.jsx